import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = {
  class: "flex col",
  style: {"width":"800px","max-width":"80vw"}
}
const _hoisted_3 = { class: "bold" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "bold" }
const _hoisted_6 = {
  class: "grid wide",
  style: {"max-height":"50vh","overflow":"scroll"}
}
const _hoisted_7 = { class: "flex g6 align-end grow justify-end" }
const _hoisted_8 = {
  key: 0,
  class: "text-green bold text-muted no-mobile"
}
const _hoisted_9 = {
  key: 1,
  class: "text-red text-muted no-mobile"
}
const _hoisted_10 = {
  class: "flex col",
  style: {"width":"400px","max-width":"80vw"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center align-center grow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"filter":"brightness(2%)"},
    src: "https://www.koovea.com/app/uploads/2022/12/Logo.svg"
  })
], -1)
const _hoisted_12 = { class: "flex col" }
const _hoisted_13 = { class: "container" }
const _hoisted_14 = { class: "flex col g24" }
const _hoisted_15 = { class: "flex justify-between" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "flex align-center" }
const _hoisted_21 = { class: "flex align-center" }
const _hoisted_22 = { class: "text-muted" }
const _hoisted_23 = { class: "flex align-center" }
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = {
  key: 0,
  class: "flex align-center"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Prix de la licence : ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h1", { class: "subtitle" }, "Koovea", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  style: {"filter":"brightness(5000%)"},
  src: "https://www.koovea.com/app/uploads/2022/12/Logo.svg"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h1", { class: "subtitle" }, "Contacts", -1)
const _hoisted_30 = { class: "grid wide" }
const _hoisted_31 = { class: "text-muted no-mobile" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WideCard = _resolveComponent("WideCard")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_SeIllustration = _resolveComponent("SeIllustration")!
  const _component_ReadonlyField = _resolveComponent("ReadonlyField")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeCountryDropdown = _resolveComponent("SeCountryDropdown")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SeModal, {
      ref: "detailModal",
      title: "Détails"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, "Etablissements actifs : " + _toDisplayString(_ctx.activeStores.length), 1),
          _createElementVNode("span", _hoisted_4, [
            _createTextVNode("Nombre de sondes Koovea liés : "),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.probesCount), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeStores, (store) => {
              return (_openBlock(), _createBlock(_component_WideCard, {
                key: store.ref?.id,
                icon: "/ico/store.svg",
                title: store.name,
                redirectPage: "account",
                obj: store
              }, {
                subtitle: _withCtx(() => [
                  _createTextVNode(_toDisplayString(store.address), 1)
                ]),
                body: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    (
                  store.koovea_sticker != null && store.koovea_sticker != ''
                )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Koovea actif ✅ "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, "Koovea inactif"))
                  ])
                ]),
                _: 2
              }, 1032, ["title", "obj"]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      ref: "kooveaModal",
      title: "Identifiants"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("form", _hoisted_12, [
            _createVNode(_component_SeInput, {
              value: _ctx.state.kooveaEmail,
              modelValue: _ctx.state.kooveaEmail,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.kooveaEmail) = $event)),
              placeholderBase: "Nom de compte"
            }, null, 8, ["value", "modelValue"]),
            _createVNode(_component_SeInput, {
              modelValue: _ctx.state.kooveaPasswordClear,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.kooveaPasswordClear) = $event)),
              placeholderBase: "Mot de passe du compte",
              type: "password"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_SeButton, {
            ref: "kooveaBtn",
            onPress: _ctx.closeKooveaModal,
            class: "w100"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Ok")
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_NavHeader, {
      backButton: "true",
      title: _ctx.state.distributor!.name + ' (' + _ctx.state.distributor!.countries.join(',') + ')'
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_ReadonlyField, {
            locked: _ctx.role != _ctx.Role.Admin,
            class: "flex justify-between align-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SeIllustration, {
                onFilePick: _ctx.pickIllustration,
                src: _ctx.state.distributor!.logo != null
              ? _ctx.state.distributor!.logo
              : '/ico/distributors2.svg'
              
              }, null, 8, ["onFilePick", "src"])
            ]),
            _: 1
          }, 8, ["locked"]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_SeButton, {
              onPress: _ctx.openDetailModal,
              icon: "ico/info.svg",
              ref: "infoBtn",
              lass: "w100"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Détails")
              ]),
              _: 1
            }, 8, ["onPress"]),
            _createVNode(_component_ReadonlyField, {
              locked: _ctx.role != _ctx.Role.Admin
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ToggleSwitch, {
                  modelValue: _ctx.state.distributor!.active,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.distributor!.active) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["locked"]),
            _createVNode(_component_SeButton, {
              ref: "modifyBtn",
              onPress: _ctx.updateDistributor,
              icon: "/ico/save.svg",
              tooltip: _ctx.Lang.getI18N('save')
            }, null, 8, ["onPress", "tooltip"])
          ])
        ]),
        _createVNode(_component_ReadonlyField, {
          locked: _ctx.role != _ctx.Role.Admin,
          class: "flex col g24"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_SeInput, {
                placeholder: _ctx.Lang.getI18N('name'),
                modelValue: _ctx.state.distributor!.name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.distributor!.name) = $event))
              }, null, 8, ["placeholder", "modelValue"]),
              _createVNode(_component_SeInput, {
                modelValue: _ctx.state.distributor!.address,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.distributor!.address) = $event)),
                placeholder: _ctx.Lang.getI18N('address')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_SeInput, {
                modelValue: _ctx.state.distributor!.postal_code,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.distributor!.postal_code) = $event)),
                placeholder: _ctx.Lang.getI18N('postal-code')
              }, null, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_SeInput, {
                modelValue: _ctx.state.distributor!.city,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.distributor!.city) = $event)),
                placeholder: _ctx.Lang.getI18N('city')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_SeInput, {
                modelValue: _ctx.state.distributor!.phone,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.distributor!.phone) = $event)),
                placeholder: _ctx.Lang.getI18N('phone-number')
              }, null, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_SeInput, {
                modelValue: _ctx.state.distributor!.email,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.distributor!.email) = $event)),
                placeholder: _ctx.Lang.getI18N('email')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.Lang.getI18N("country")) + ":", 1),
                _createVNode(_component_SeCountryDropdown, { ref: "countrySelect" }, null, 512)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.Lang.getI18N("billing-cycle")) + ":", 1),
                _createVNode(_component_SeDropdown, {
                  modelValue: _ctx.state.distributor!.billing_cycle,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.distributor!.billing_cycle) = $event)),
                  titleFunc: (x) => _ctx.getBillingCycleTitle(x),
                  ref: "billingCycleSelect"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SeDropdownItem, { value: 1 }),
                    _createVNode(_component_SeDropdownItem, { value: 12 * 5 })
                  ]),
                  _: 1
                }, 8, ["modelValue", "titleFunc"])
              ]),
              (_ctx.role == _ctx.Role.Admin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(_component_SeInput, { ref: "licencePrice" }, null, 512)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["locked"]),
        _hoisted_27,
        _createVNode(_component_SeButton, { onPress: _ctx.openKooveaModal }, {
          default: _withCtx(() => [
            _hoisted_28
          ]),
          _: 1
        }, 8, ["onPress"]),
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (contact) => {
            return (_openBlock(), _createBlock(_component_WideCard, {
              key: contact.ref?.id,
              icon: "/ico/account.svg",
              title: contact.name + ' ' + contact.surname,
              redirectPage: "account",
              obj: contact
            }, {
              subtitle: _withCtx(() => [
                _createTextVNode(_toDisplayString(contact.email), 1)
              ]),
              footer: _withCtx(() => [
                _createElementVNode("h1", _hoisted_31, _toDisplayString(contact.stores.length) + " stores ", 1)
              ]),
              _: 2
            }, 1032, ["title", "obj"]))
          }), 128))
        ])
      ])
    ])
  ]))
}